import { Modal } from "@4uhub/lib4uhub";
import { memo } from "react";
import { useTranslation } from "react-i18next";

import { ITicketAutomationReceivedRule } from "../../../services/tasySchedMenu.service";
import InsuranceForm from "./InsuranceForm";

const isGuid = (value?: string) =>
  !!value &&
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(value);

interface IInsuranceCategoryModalProps {
  open: boolean;
  insurance: any | null;
  patient: {
    id: string;
    individualId?: string;
    name: string;
  };
  rule?: ITicketAutomationReceivedRule | null;
  establishmentCode?: string;
  onClose: () => void;
  onSuccess: (insurance: any) => void;
}

const InsuranceCategoryModal: React.FC<IInsuranceCategoryModalProps> = ({
  open,
  insurance,
  patient,
  rule,
  establishmentCode,
  onClose,
  onSuccess,
}) => {
  const { t } = useTranslation();

  return (
    <Modal
      open={open}
      onClose={onClose}
      title={`${t("page.schedules.newSchedule.insurance")}`}
      maxDialogWidth="xs"
    >
      {insurance && (
        <InsuranceForm
          individual={{
            id: patient.individualId || patient.id,
            name: patient.name,
          }}
          rule={rule}
          establishmentCode={establishmentCode}
          initialInsurance={insurance}
          insuranceId={isGuid(insurance.code) ? insurance.code : undefined}
          disableInsurance
          onSuccess={onSuccess}
        />
      )}
    </Modal>
  );
};

export default memo(InsuranceCategoryModal);
